import { Navigate, Route, Routes } from "react-router-dom"
import Protected from "../components/protected"
import Dashboard from "../views/Dashboard"
import Login from "../views/Login"
import UserView from "../views/User"
import PsicomotorView from "../views/Psicomotor"
import VacunasView from "../views/Vacunas"
import AlimentacionView from "../views/Alimentacion"
import DenticionView from "../views/Denticion"
import PublicidadView from "../views/publicidad/Publicidad"
import CreateView from "../views/Create"
import Help from "../views/Help"
import TermsConditions from "../views/Terms"
import DeactivateUser from "../views/DeactivateUser"
import { useAuth } from "react-oidc-context"
import { useEffect } from "react"
import AdForm from "../views/publicidad/form"
import SponsorView from "../views/auspiciante"

export const AppRouter = () => {
    const auth = useAuth()

    useEffect(() => {
        if (!auth.isAuthenticated && !auth.isLoading) {
            auth.signinRedirect()
        }
    }, [auth.isAuthenticated, auth.isLoading, auth])

    if (auth.isAuthenticated) {
        return (
            <Routes>
                <Route path="/*" element={<Navigate to="/advertising" />} /> 
                <Route path="/users" element={
                    <Protected >
                        <UserView />
                    </Protected>
                } />
                {/* <Route path="/development" element={
                    <Protected >
                        <PsicomotorView />
                    </Protected>
                } />
                <Route path="/vaccines" element={
                    <Protected >
                        <VacunasView />
                    </Protected>
                } />
                <Route path="/feeding" element={
                    <Protected >
                        <AlimentacionView />
                    </Protected>
                } />
                <Route path="/dentition" element={
                    <Protected >
                        <DenticionView />
                    </Protected>
                } /> */}
                <Route path="/sponsor" element={
                    <Protected >
                        <SponsorView />
                    </Protected>
                } />
                <Route path="/advertising" element={
                    <Protected >
                        <PublicidadView />
                    </Protected>
                } />
                <Route path="/advertising-form" element={
                    <Protected >
                        <AdForm />
                    </Protected>
                } />
                <Route path="/advertising-form/:id" element={
                    <Protected >
                        <AdForm />
                    </Protected>
                } />
                {/* <Route path="/create" element={
                    <Protected >
                        <CreateView />
                    </Protected>
                } /> */}
                {/* <Route path="login" element={<Login />} />
                <Route path="help" element={<Help />} />
                <Route path="terms" element={<TermsConditions />} />
                <Route path="delete-user" element={<DeactivateUser />} />
                <Route path="/*" element={<Navigate to="/" />} /> */}
            </Routes>
        )
    }

    // Mostrar un loading mientras se autentica o redirigir
    if (auth.isLoading) {
        return <div>Cargando...</div>
    }

    // Si no está autenticado y no está cargando, mostrar página de login
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route path="help" element={<Help />} />
            <Route path="terms" element={<TermsConditions />} />
            <Route path="delete-user" element={<DeactivateUser />} />
            {/* <Route path="/*" element={<Navigate to="/login" />} /> */}
        </Routes>
    )
}
